module.exports = __webpack_public_path__ + "static/media/default_cover.22e5f56b.png";